<template>
  <div>
    <header
      :class=" ['section', 'business-summary', { 'is-review-summary': isReviewDetailsPage }]">
      <p class="has-text-centered spinner">
        <img
          v-if="fetchingBusiness"
          alt="Getting business detail"
          src="/static/img/others/spinner.svg"
        />
      </p>
      <div v-if="!fetchingBusiness" class="level is-mobile">
        <!-- ITEM PROP HERE ONLY -->
        <div v-if="!isReviewDetailsPage" class="level-left" itemscope itemtype="http://schema.org/LocalBusiness">
          <h1 hidden itemprop="name" v-html="record.businessName"></h1>
          <div hidden itemprop="image" itemscope itemtype="http://schema.org/ImageObject">
            <span itemprop="url" v-html="businessLogo"></span>
          </div>
          <div v-if="totalReviews > 0" hidden itemprop="aggregateRating" itemscope itemtype="http://schema.org/AggregateRating">
            <span hidden itemprop="ratingValue" v-html="averageRating"></span>
            <span hidden itemprop="reviewCount" v-html="totalReviews"></span>
          </div>

          <div class="level-item mobile-level">
            <p v-if="!isReviewDetailsPage" class="summary">
              <strong
                class="business-name"
                v-html="businessTitle + $options.filters.breakSent(record.businessName)"
              >
              </strong>
              <rating
                :business-detail="smallStars"
                :stars="reviewAverage"
                class="avg-rating starRating"
              >
              </rating>
              <span class="review-summary is-hidden-mobile" v-html="reviewSummaryHtml"></span>
              <span class="review-summary is-hidden-tablet" v-html="reviewSummaryHtml"></span>
            </p>
          </div>
        </div>
        <div class="buttons">
          <a :href="facebookReviewUrl"
             class="button review-button"
             target="_blank"
          >
            WRITE A REVIEW
          </a>
        </div>
      </div>
    </header>
    <hr>
    <section
      :class="['section', 'business-summary', 'review-list', { 'is-review-summary': isReviewDetailsPage }]">
      <BusinessItemReviewsList :business="business"/>
    </section>
    <section
      :class="['section','review-footer', 'business-summary', { 'is-review-summary': isReviewDetailsPage }]">
      <div>
        <div class="footer">
          <p>Learn from other people’s experiences.
            <a href="/" target="_blank">Read and write reviews</a>
          </p>
          <h1 class="title has-text-centered">
            <a href="/" target="_blank"><img alt="logo" src="/static/img/logo/HelloPeter.png" width="220"></a>
          </h1>
        </div>

      </div>
    </section>
  </div>
</template>
<script>
import { misc } from '@/mixins'
import axios from 'axios'
import Rating from '@/components/Rating'
import BusinessItemReviewsList from '@/pages/business/BusinessItemReviewsList'

export default {
  name: 'BusinessReviewsList',
  metaInfo () {
    return {
      title: 'Facebook-Review List'
    }
  },
  mixins: [misc],
  components: {
    Rating,
    BusinessItemReviewsList
  },
  data () {
    return {
      hasStats: false,
      hasDetail: false,
      reviewDetailAuthor: '',
      reviewDetailDate: '',
      averageResponseTime: 0,
      fetchingBusiness: false,
      fetchingStats: false,
      record: undefined,
      stats: undefined,
      smallStars: true,
      monthRecords: [],
      oneStar: 0,
      twoStar: 0,
      threeStar: 0,
      fourStar: 0,
      fiveStar: 0,
      totalReviews: 0,
      averageRating: 0,
      socialLinks: [],
      keywords: [],
      showTooltip: false,
      businessTitle: 'See what some customers are saying about ',
      consumerFrontendUrl: process.env.APP_URL,
      source: 'RkFDRUJPT0tfVEFC',
      business: ''
    }
  },
  computed: {
    /**
     * Create facebook review url to write a review
     * return {String}
     */
    facebookReviewUrl () {
      return `${this.consumerFrontendUrl}/write-a-review/${this.business}?source=${this.source}&r=true`
    },
    /**
     * Load the review data
     * return {void}
     */
    loaded () {
      return this.fetchingBusiness === false &&
        this.fetchingStats === false &&
        typeof this.record !== 'undefined' &&
        typeof this.stats !== 'undefined'
    },
    /**
     * Give average review data
     * return {void}
     */
    reviewAverage () {
      if (typeof this.stats !== 'undefined') {
        return Math.floor(parseFloat(this.stats.reviewAverage))
      }
      return 0
    },
    /**
     *  Create Summary Html For Review Details
     *  return {void}
     */
    reviewSummaryHtml () {
      if (typeof this.stats !== 'undefined') {
        const total = parseInt(this.stats.totalReviews)
        if (typeof this.stats.reviewAverage !== 'undefined' && this.stats.reviewAverage !== null) {
          const avg = parseFloat(this.stats.reviewAverage).toFixed(2)
          return `<span class="average-rating-new"> Average rating of
                    <span class="has-text-weight-bold">${avg}</span>
                    </span><span class="see-reviews">See all ${total} reviews on
                    <a target="_blank" href="/${this.business}">Hellopeter</a>
                    </span>`
        }
        return `Average rating of
                  <span class="has-text-weight-bold">0</span>
                  See all <span>${total} reviews on
                  <a target="_blank" href="/${this.business}">Hellopeter</a>
                  </span>`
      }
      return ''
    },
    /**
     * Count all review
     * return {void}
     */
    reviewCount () {
      if (typeof this.stats !== 'undefined') {
        if (this.stats.totalReviews < 100) {
          return `${this.stats.totalReviews}&nbsp;reviews&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
        }
        return `${this.stats.totalReviews}&nbsp;reviews`
      }
      return ''
    },
    /**
     *  Create business logo
     *  return {void}
     */
    businessLogo () {
      if (typeof this.record !== 'undefined') {
        if (this.record.businessDetails.logo !== null && this.record.businessDetails.logo !== '') {
          return this.record.businessDetails.logo
        }
      }
      return this.noLogo.url
    },
    /**
     * Check review detail page
     * return {void}
     */
    isReviewDetailsPage () {
      return typeof this.$route.params.permalink !== 'undefined'
    },
  },
  created () {
    this.business = this.$route.params.slug
    this.getBusinessDetail()
    this.getBusinessStats()
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Facebook'
    })
  },
  methods: {
    /**
     * Get Business Detail
     * @return {void}
     */
    async getBusinessDetail () {
      this.fetchingBusiness = true
      axios.get(`/consumer/business/${this.business}`)
        .then(({ data }) => {
          this.record = data
          this.hasDetail = true
          if (typeof data.businessDetails !== 'undefined') {
            this.keywords = data.businessDetails.keywords
            window.events.$emit('loaded-business-keywords', {
              keywords: this.keywords
            })
          }
          this.fetchingBusiness = false
          this.addSocialLinks()
        })
        .catch((error) => {
          this.fetchingBusiness = false
        })
    },
    /**
     * Get Business Star
     * @return {void}
     */
    async getBusinessStats () {
      this.fetchingStats = true
      axios.get(`/consumer/business-stats/${this.business}`)
        .then(({ data }) => {
          this.hasStats = true
          this.stats = data
          this.totalReviews = parseInt(data.totalReviews)
          this.averageRating = parseFloat(data.reviewAverage)
          this.averageResponseTime = data.avgResponseTime
          if (typeof data.monthlyStats !== 'undefined' && typeof data.monthlyStats.months !== 'undefined') {
            this.monthRecords = data.monthlyStats.months
          }
          if (typeof data.reviewRatings !== 'undefined' && typeof data.reviewRatings.rows !== 'undefined') {
            data.reviewRatings.rows.forEach((row) => {
              switch (row[0]) {
                case '1 Star':
                  this.oneStar = row[1]
                  break
                case '2 Stars':
                  this.twoStar = row[1]
                  break
                case '3 Stars':
                  this.threeStar = row[1]
                  break
                case '4 Stars':
                  this.fourStar = row[1]
                  break
                case '5 Stars':
                  this.fiveStar = row[1]
                  break
                default:
                  break
              }
            })
          }
          this.fetchingStats = false
        })
        .catch((error) => {
          console.log('error', error)
          this.fetchingStats = false
        })
    }
  },
  filters: {
    precise (value, length = 2) {
      if (!value) {
        return ''
      }
      return value.toFixed(length)
    },

    /**
     * Break sentence if longer than given length
     * @param {String} sent Sentence to break
     * @param {Number} charsInLine Number of character to tiyaa in a single line
     * @returns {String} Formated sentence
     */
    breakSent (sent, charsInLine = 40) {
      sent = sent.trim()
      if (window.innerWidth < 1025 || !sent || sent.length <= charsInLine) { // Sentence is less than 40 characters
        return sent
      }

      if (!sent.charAt(charsInLine - 1) || !sent.charAt(charsInLine)) { // At 39th index, a word is completing. So we can break the sentence.
        return `${sent.substr(0, charsInLine)} <br /> ${this.breakSent(sent.substr(charsInLine))}`
      }

      // Word is not completing at 39th index. Find index of start of the current word
      const wordStart = sent.lastIndexOf(' ', charsInLine - 1) + 1
      if (!wordStart) { // Word is first word in sentence
        const nextWord = sent.indexOf(' ', charsInLine - 1) + 1 // Finding next word index
        if (nextWord > 0) { // We have next word in sentence. Extract upto next word and print them
          return `${sent.substring(0, nextWord)} <br /> ${this.breakSent(sent.substr(nextWord))}`
        } else { // No next word found. Print whole sentence.
          return sent
        }
      } else { // There are words before the word. Extract and print them
        return `${sent.substring(0, wordStart)} <br /> ${this.breakSent(sent.substr(wordStart))}`
      }
    }
  }
}
</script>
<style scoped>
header {
  position: fixed;
  clear: both;
  width: 100%;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 5px 5px -3px rgba(218, 205, 205, 0.4);
  padding: 15px !important;
}

body {
  overflow-y: hidden !important;
}

.review-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;

}

.section.business-summary.review-list {
  margin-bottom: 13%;
  height: 100%;
  min-height: 230px;
  max-height: 545px;
  overflow-y: auto;
  overflow-x: hidden;
}

.section.review-footer.business-summary {
  padding: 2.1rem 1px !important;
}

.section.review-footer.business-summary .footer {
  padding-top: 25px;
  padding-bottom: 25px;
}

.section.review-footer.business-summary .footer p {
  display: inline-block;
}

.section.review-footer.business-summary .footer h1 {
  top: 23px;
}

.section.business-summary {
  padding: 0px !important;
}

.section.section.business-summary.review-list {
  margin-top: 90px;
}

.business-logo {
  width: 140px;
  margin-right: 20px;
  border-radius: 50%;
  border: 1px solid #F5F5F5;
}

.section.business-summary {
  width: 100%;
  margin: 0 auto;
}

.section.business-summary.is-review-summary {
  padding: 1.5rem 0;
}

.business-name, .industry > a, .industry > a:hover, .industry > a:visited, .review-summary, .review-summary {
  color: #58595B !important;
}

.industry > a {
  text-decoration: none;
}

.business-name {
  font-size: 1.1rem;
}

.industry {
  font-size: 1rem;
}

.review-summary {
  font-size: 0.85rem;
}

.responding-business {
  width: 42px;
  position: relative;
  margin-left: -34px;
  margin-bottom: -100px;
  margin-right: 21px;
}

.container-box {
  display: block;
  width: 174px;
  box-shadow: 0px 0px 23px -1px rgba(166, 159, 166, 0.32);
  padding: 0.7rem;
}

.container-box > p {
  width: 100%;
  display: block;
  padding: 0;
  text-align: center;
}

.container-box > p:nth-child(odd) {
  font-size: 0.75rem;
}

.container-box > p:nth-child(even) {
  font-size: 2.5rem;
}

.nps-total {
  display: block;
  width: 68px;
  height: 68px;
  border: 5px solid #2FABE1;
  border-radius: 50%;
  font-size: 1.4rem;
  text-align: center;
  line-height: 60px;
  margin: 6px auto;
}

.level-right > .level-item:not(:last-child) {
  margin-right: 1.5rem;
}

.section.business-columns {
  border-top: 1px solid #C9C9C9;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-image: linear-gradient(to right, #ffffff 65%, #F5F5F5 20%);
}

.right-column > .container {
  width: 75%;
  margin-left: 28%;
  color: #58595B;
}

.industry-rank-card {
  background-color: #ffffff;
}

.industry-rank-card, .vue-chart-container {
  box-shadow: 0px 0px 23px -1px rgba(166, 159, 166, 0.32);
}

.right-column > .container > h4 {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  margin-top: 2rem;
}

.right-column > .container > h4:first-child {
  margin-top: 1rem;
}

.columns > .industry-rank-card {
  margin-right: 10px;
  text-align: center;
}

.columns > .industry-rank-card > span:first-child {
  font-weight: bold;
}

.columns > .industry-rank-card:last-child {
  margin-right: 0;
}

.business-description {
  font-size: 0.85rem;
  margin-bottom: 25px;
}

.button.is-outlined {
  background-color: transparent;
  color: #30AAE1;
  border: 1px solid #30AAE1;
  border-radius: 0;
  font-size: 0.85rem;
  padding: 1.3rem 2rem;
}


.mini-title, .mini-detail {
  color: #707070;
  font-size: 0.85rem;
}

.mini-title {
  font-weight: bold;
}

.mini-detail {
  margin-top: 5px;
  margin-bottom: 15px;
}

.left-pane {
  margin: 35px 35px 35px auto;
  width: 100%;
  max-width: 750px;
}

.tag.is-white {
  margin-right: 10px;
  margin-bottom: 10px;
  color: #707070;
  border-radius: 0;
}

.business-name > a, .business-name > a:hover, .business-name > a:visited {
  text-decoration: none;
  color: #58595B;
}

.review-author-details {
  font-size: 0.9rem;
  color: #8A8C91;
}

.business-name.review-details {
  font-size: 1.2rem;
}

.left-pane iframe {
  width: 100% !important;
}

.no-nps-data {
  width: 68px;
  height: 68px;
  color: #707070;
  font-size: 0.8rem !important;
  text-align: center;
  line-height: 23px;
  margin: 5px auto;
  display: flex !important;
  align-items: center;
}

.line-heigth-23 {
  line-height: 23px !important;
}

.zero-trust-index {
  line-height: 1rem !important;
  top: 1px !important;
  font-weight: normal !important;
}

.is-this-your-business > a, .is-this-your-business > a:visited, .is-this-your-business > a:hover {
  font-size: 0.9rem;
  color: #2EAAE1;
  text-decoration: underline;
}

.is-this-your-business.is-hidden-mobile {
  margin-top: -18px;
  margin-bottom: -18px;
}

@media screen and (max-width: 1024px) {
  .business-logo {
    width: 111px;
  }

  .section.business-summary {
    padding: 2.1rem !important;
  }

  .responding-business {
    width: 34px;
    position: relative;
    margin-left: -50px;
    margin-bottom: -80px;
    margin-right: 5px;
  }

  .business-name {
    font-size: 1rem;
  }

  .industry {
    font-size: 0.8rem;
  }

  .review-summary {
    font-size: 0.75rem;
  }

  .summary {
    /*max-width: 150px;*/
    line-height: 1.2rem;
  }

  .container-box {
    width: 114px;
    height: 136px;
  }

  .section.business-summary.is-review-summary .summary {

  }
}

@media screen and (max-width: 767px) {

  .verified-biz {
    width: 42px;
    margin-left: -22px;
    margin-bottom: -15px;
  }

  .section.business-summary {
    padding: 1.3rem;
  }

  .section.business-summary.is-review-summary {
    display: none;
  }

  .business-logo {
    width: 75px;
    position: relative;
    top: -20px;
  }

  .responding-business {
    width: 23px;
    position: relative;
    margin-left: -40px;
    margin-bottom: -12px;
    margin-right: 5px;
  }

  .summary-trust-index {
    font-size: 0.9rem;
    line-height: 2rem;
    position: relative;
    top: -23px;
  }

  .summary {
    width: 100%;
  }

  .review-count {
    font-size: 0.75rem;
    position: relative;
    left: 130px;
    top: -20px;
  }

  .section.business-columns {
    border: none;
  }

  .left-pane.is-review-details {
    margin: 0;
  }

  .level-item.mobile-level {
    padding-bottom: 12px;
  }

  .section.business-columns {
    background-image: none;
  }
}

.nps-component-icon {
  cursor: pointer;
  position: absolute;
  bottom: 9px;
}

.fa-check-circle {
  color: #4db888;
  margin-right: 6px;
  height: 25px;
}

.fa-check-circle-mobile {
  color: #4db888;
  margin-right: 6px;
  height: 20px;
}

.verify-text {
  display: flex;
  position: relative;
  color: #4ba9e0 !important;
  margin-top: 8px;
}

.verify-text-mobile {
  display: flex;
  position: relative;
  color: #4ba9e0 !important;
  margin-top: -20px;
}

.verified-biz-desktop {
  width: 42px;
  margin-left: -27px;
  margin-bottom: -100px;
}

.avg-rating {
  margin-bottom: 5px !important;
  margin-top: 6px !important;
}

.verify-text > span {
  margin-top: 2px;
}

.net-promoter {
  position: relative;
}

.nps-data {
  padding-bottom: 16px !important;
}

.v-popover {
  height: 0px !important;
}

.level .widget-section {
  width: 100%;
  max-width: inherit;
}

.container-box p a {
  color: black;
}

.section.business-summary.review-list {
  padding-top: 1rem !important;
}

.footer {
  max-width: 1036px;
  background-color: #555e65;
  padding: 20px 0px;
  position: relative;
  width: 100%;
}

.footer p {
  color: #fff;
  padding: 0px 60px;
  font-size: 14px;
}

.footer p a {
  color: #fff;
  text-decoration: underline;
}

h1.title.has-text-centered {
  position: absolute;
  bottom: 5px;
  right: 90px;
  width: 104px;
  height: 40px;
}

.review-header {
  width: 1036px;
  height: 1166px;
  background-color: #ffffff;
}

.button {
  border: 0;
  border-radius: 0;
  background-color: #30aae1;
  color: #ffffff;
  font-size: 0.85rem;
  padding: 1.3rem 2rem;
}

.button.is-outlined {
  background-color: #ffffff;
  color: #30aae1;
  border: 1px solid #30aae1;
}

.buttons .button:not(:last-child):not(.is-fullwidth) {
  margin-right: 1rem;
}

.headingTop {
  width: 403px;
  height: 22px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.business-detail > li[data-v-68a0414d] {
  font-size: 10px !important;
  margin-left: 0;
}

.business-detail > li[data-v-68a0414d] {
  font-size: 10px;
  margin-left: 0;
}

.review-card > li[data-v-68a0414d], .industry-business > li[data-v-68a0414d] {
  font-size: 10px;
  margin-left: 0;
}

starNew.business-detail {
  font-size: 1rem;
  width: 120px !important;
}

p.summary {
  position: relative !important;
}

.average-rating-new {
  position: absolute !important;
  left: 107px !important;
  top: 29px !important;
  font-size: 12px;
}

.see-reviews {
  font-size: 12px;
  position: absolute;
  top: 54px;
}

.review-button {
  margin-right: 40px;
  height: 40px;
  width: 139px;
}

@media (max-width: 991px) {
  .footer {
    max-width: 1036px;
    width: 100% !important;
  }
}

@media (max-width: 479px) {
  .footer p {
    font-size: 12px !important;
    padding: 0px 10px !important;
  }

  .review-button {
    margin-right: 40px !important;;
    position: absolute !important;
    top: 64px !important;
    right: 28px !important;
  }

  .headingTop {
    font-size: 12px !important;
  }

  h1.title.has-text-centered {
    position: absolute;
    bottom: 2px !important;
    right: 30px !important;
    width: 64px !important;
  }
}

@media (max-width: 375px) {
  .review-button {
    margin-right: 40px !important;
    position: absolute !important;
    top: 109px !important;
    right: -12px !important;
    padding: 15px 18px !important;
    font-size: 14px !important;
  }

  h1.title.has-text-centered {
    position: absolute;
    bottom: -21px !important;
    right: 30px !important;
    width: 64px !important;
    font-size: 10px !important;
  }

  .footer p {
    font-size: 10px !important;
  }

  .average-rating-new {
    top: 28px !important;
  }
}

@media (max-width: 360px) {
  .review-button {
    margin-right: 40px !important;
    position: absolute !important;
    top: 48px !important;
    right: -23px !important;
    color: #fff !important;
    width: 110px;
    height: 33px;
    font-size: 10px;
    padding: 15px 18px !important;
    font-size: 12px !important;
    background: #30aae1 !important;
  }

  .business-name {
    font-size: 11px !important;
  }

  .section business-summary {
    padding: 0px 10px !important;
  }

  .section {
    padding: 10px 1.5rem;
  }

  .business-detail {
    font-size: 2rem !important;
    width: 120px !important;
  }

  .section.business-summar {
    padding: 10x !important;
  }

  .headingTop {
    font-size: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessReviewsList.vue